const enums = {
    waitingStatus: ['Active', 'Rejected'],
    customerType: ['Tenant', 'Lead'],
    waitingSource: ['Facilitate', 'Website'],
};

export default enums;
